import { render, staticRenderFns } from "./FastOrdersHead.vue?vue&type=template&id=83c51e3c&scoped=true"
import script from "./FastOrdersHead.vue?vue&type=script&lang=js"
export * from "./FastOrdersHead.vue?vue&type=script&lang=js"
import style0 from "./FastOrdersHead.vue?vue&type=style&index=0&id=83c51e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c51e3c",
  null
  
)

export default component.exports